import {
  Box,
  CircularProgress,
  Stack,
  Typography
} from "@mui/joy";
import { ModalBackdrop } from "@mui/joy/Modal/Modal";
import axios from "axios";
import { collection, orderBy, query } from "firebase/firestore";
import React from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router";
import { collectionData } from "rxfire/firestore";
import { auth, db, onAuthStateChanged } from "../config/firebase";
import { convert, getNotification, getUserInfo } from "../config/services";
import {
  notification$,
  notificationall$,
  userinfo$,
  walletData$,
} from "../redux/action";

export function DashboardIndex() {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(true);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const dispatch = useDispatch();
  let totalbalance = [];

  React.useEffect(() => {
    // setLoading(true);
    onAuthStateChanged(auth, (user) => {
      if (user) {
        //get notifications
        getNotification(user.uid);
        //get user infos
        getUserInfo(user.uid).subscribe((userData) => {
          const {
            btc_balance,
            bnb_balance,
            tron_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,
          } = userData;

          //totalbalance
          totalbalance = [
            btc_balance,
            bnb_balance,
            tron_balance,
            eth_balance,
            usdt_balance,
            usdterc20_balance,
          ].reduce((prv, cur) => {
            return prv + cur;
          }, 0);

          dispatch(
            userinfo$({ ...userData, id: user.uid, totalBalance: totalbalance })
          );

          //get crypto info
          axios
            .get(
              "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin%2Cethereum%2Cbinancecoin%2Ctron%2Ctether%2C&vs_currencies=usd&include_24hr_change=true"
            )
            .then((res) => {
              //console.log(res.data);

              (async function () {
                await convert.ready(); //Wait for the initial cache to load

                dispatch(
                  walletData$([
                    {
                      coinname: "BITCOIN",
                      cointype: "btc_balance",
                      price: res.data.bitcoin.usd,
                      difference: res.data.bitcoin.usd_24h_change,
                      balance: btc_balance,
                      balancecoin: convert.USD.BTC(`${btc_balance}`),
                      code: "BTC",
                      image: "./images/coins/btc.png",
                      address: "bc1qvcny9273tekt7cg85k9kt2g5k0dhpwdrjp356x",
                      network: "BTC",
                      thumbimage: "./images/coins/btc.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "ETHERUEM",
                      cointype: "eth_balance",
                      price: res.data.ethereum.usd,
                      difference: res.data.ethereum.usd_24h_change,
                      balance: eth_balance,
                      balancecoin: convert.USD.ETH(`${eth_balance}`),
                      code: "ETH",
                      image: "./images/coins/eth.png",
                      address: "0x2F39B4eC094DF801837b338211933E2d425fb332",
                      network: "ERC20",
                      thumbimage: "./images/coins/eth.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "BNB SMART",
                      cointype: "bnb_balance",
                      price: res.data.binancecoin.usd,
                      difference: res.data.binancecoin.usd_24h_change,
                      balance: bnb_balance,
                      balancecoin: convert.USD.BNB(`${bnb_balance}`),
                      code: "BNB",
                      image: "./images/coins/bnb.png",
                      address: "bnb13m39rjwfj7kjpeh627d8hmfx2k9xgwckvm2lmn",
                      network: "BEP20",
                      thumbimage: "./images/coins/bnb.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "TRON",
                      cointype: "tron_balance",
                      price: res.data.tron.usd,
                      difference: res.data.tron.usd_24h_change,
                      balance: tron_balance,
                      balancecoin: convert.USD.TRX(`${tron_balance}`),
                      code: "TRX",
                      image: "./images/coins/tron.png",
                      address: "TZ9YZp1CjnL5o4YFifhWGwE6DdVAvmebJg",
                      network: "TRC20",
                      thumbimage: "./images/coins/tron.png",
                      contractaddress: false,
                    },
                    {
                      coinname: "USDT",
                      cointype: "usdt_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdt_balance,
                      balancecoin: convert.USD.USDT(`${usdt_balance}`),
                      code: "USDT TRC20",
                      image: "./images/coins/usdt.png",
                      address: "TZ9YZp1CjnL5o4YFifhWGwE6DdVAvmebJg",
                      network: "TRC20",
                      thumbimage: "./images/coins/tron.png",
                      contractaddress: true,
                    },
                    {
                      coinname: "USDT",
                      cointype: "usdterc20_balance",
                      price: res.data.tether.usd,
                      difference: res.data.tether.usd_24h_change,
                      balance: usdterc20_balance,
                      balancecoin: convert.USD.USDT(`${usdterc20_balance}`),
                      code: "USDT ERC20",
                      image: "./images/coins/usdt.png",
                      address: "0x2F39B4eC094DF801837b338211933E2d425fb332",
                      network: "ERC20",
                      thumbimage: "./images/coins/eth.png",
                      contractaddress: true,
                    },
                  ])
                );
              })().then(() => {
                setLoading(false);
              });
            })
            .catch((error) => console.log(error));
        });
        const usertransactionref = query(
          collection(db, "users", user.uid, "transactions"),
          // where("seen", "!=", true),
          orderBy("timestamp", "desc")
        );
        const notifications = collectionData(usertransactionref).subscribe(
          (data) => {
            const getAllDocsWithoutField = (fieldName) => {
              const docsWithoutField = data.filter((doc) => {
                const data = doc;
                return !(fieldName in data);
              });

              return docsWithoutField;
            };
            dispatch(notificationall$(data.length));
            dispatch(notification$(getAllDocsWithoutField("seen").length));
          }
        );
        return () => {
          notifications.unsubscribe();
        };
      } else {
        navigate("/auth/login");
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <script src="//code.jivosite.com/widget/b9aXTHmcY1" async />
      </Helmet>
      {loading ? (
        <ModalBackdrop
          sx={{
            flexDirection: "column",
            backgroundColor: (theme) => theme.palette.background.paper,
            zIndex: 1000,
          }}
        >
          <Box
            mt={1}
            display={"flex"}
            justifyContent={"center"}
            position={"relative"}
            top={"40%"}
          >
            <Stack spacing={1} alignItems={"center "}>
              <CircularProgress color="primary" />
              <Typography level="body-lg">Loading...</Typography>
            </Stack>
          </Box>
        </ModalBackdrop>
      ) : (
        <Outlet />
      )}
    </>
  );
}

/*
 <Helmet>
      <script src="//code.tidio.co/y4qvyvglyyragn1zlquny8um9fpsgoyg.js" async></script>
      </Helmet>

      <Backdrop open={loading}>
        <CustomCirleLoader />
      </Backdrop>
*/
